import { render, staticRenderFns } from "./TeachRoomReference.vue?vue&type=template&id=7c176fa6&"
import script from "./TeachRoomReference.vue?vue&type=script&lang=js&"
export * from "./TeachRoomReference.vue?vue&type=script&lang=js&"
import style0 from "./TeachRoomReference.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports